<mat-toolbar class="footer-toolbar">
  <a routerLink="/ueber-uns" aria-label="Über Rast-WC.de" class="footer-link">Über Rast‑WC.de</a>
  <a routerLink="/impressum" aria-label="Impressum" class="footer-link">Impressum</a>
  <a routerLink="/datenschutz" aria-label="Datenschutzerklärung" class="footer-link">Datenschutzerklärung</a>
  <span class="spacer"></span>
  <span>&copy; {{ currentYear }} Rast-WC.de</span>
</mat-toolbar>
